import React from 'react';

const PPQIntro = () => {
  return (
    <div className="PPQIntro">
      <div className="PPQIntroCopy">
        <h1>Is Hometap a good option for your homeowner?</h1>
        <p>
          See if your Homeowner might be a good candidate for a Hometap Investment by answering the questions below:
        </p>
      </div>
    </div>
  );
};

export default PPQIntro;
